<header class="masthead">
  <div class="container h-100">
    <div class="row h-100 align-items-center">
      <div class="col-12 text-center">
        <h1 class="outline-title">Social Media</h1>
      </div>
    </div>
  </div>
</header>

<section class="modern-service-hero-section py-5">
  <div class="container px-5 my-5">
    <div class="row align-items-center">
      <div class="col-lg-7">
        <a class="service-detail-back" routerLink="/servicios">
          <i class="bi bi-arrow-left"></i>
          Servicios
        </a>
        <h1 class="modern-section-title mb-3">
          Social media que construye comunidad y <span class="highlight-green">genera acción</span>
        </h1>
        <div class="section-underline"></div>
        <p class="lead text-light mb-4">
          Estrategias y gestión profesional para conectar marcas con comunidades auténticas y objetivos medibles.
        </p>
        <ul class="modern-checklist">
          <li><i class="bi bi-check-circle-fill"></i> Gestión profesional de redes sociales</li>
          <li><i class="bi bi-check-circle-fill"></i> Contenido creativo y estratégico</li>
          <li><i class="bi bi-check-circle-fill"></i> Análisis y optimización continua</li>
        </ul>
      </div>
      <div class="col-lg-5 text-center">
        <app-service-orbit-visual iconClass="bi bi-share"></app-service-orbit-visual>
      </div>
    </div>
  </div>
</section>

<!-- CARDS DE SERVICIOS -->
<section class="modern-service-cards-section py-5">
  <div class="container">
    <div class="row g-4">
      <div class="col-md-4 d-flex">
        <div class="modern-service-card glass-card w-100 text-center">
          <div class="icon-box mx-auto mb-3">
            <i class="bi bi-people"></i>
          </div>
          <h4 class="modern-service-card-title">Gestión de Redes</h4>
          <p>Administramos tus canales con contenido relevante, presencia consistente y enfoque estratégico.</p>
        </div>
      </div>
      <div class="col-md-4 d-flex">
        <div class="modern-service-card glass-card w-100 text-center">
          <div class="icon-box mx-auto mb-3">
            <i class="bi bi-pencil-square"></i>
          </div>
          <h4 class="modern-service-card-title">Contenido Creativo</h4>
          <p>Desarrollamos piezas que fortalecen identidad, conversación e intención de marca.</p>
        </div>
      </div>
      <div class="col-md-4 d-flex">
        <div class="modern-service-card glass-card w-100 text-center">
          <div class="icon-box mx-auto mb-3">
            <i class="bi bi-bar-chart-line"></i>
          </div>
          <h4 class="modern-service-card-title">Análisis y Métricas</h4>
          <p>Medimos rendimiento y generamos insights para optimizar campañas y contenidos.</p>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- SECCIÓN POR QUÉ ELEGIRNOS -->
<section class="modern-service-why-section py-5">
  <div class="container px-5 my-5">
    <div class="row align-items-center">
      <div class="col-md-6">
        <h2 class="modern-section-title mb-3">
          ¿Por qué <span class="highlight-green">elegirnos?</span>
        </h2>
        <div class="section-underline"></div>
        <ul class="modern-checklist">
          <li><i class="bi bi-check-circle-fill"></i> Experiencia en múltiples plataformas</li>
          <li><i class="bi bi-check-circle-fill"></i> Estrategias personalizadas por marca</li>
          <li><i class="bi bi-check-circle-fill"></i> Resultados medibles y reportes claros</li>
        </ul>
      </div>
      <div class="col-md-6">
        <div class="glass-card p-4">
          <p class="mb-0 text-light">
            Construyamos una comunidad digital que impulse tu marca.
          </p>
        </div>
      </div>
    </div>
  </div>
</section>
